import { render } from "./raceManager.vue?vue&type=template&id=6b936f89&scoped=true"
import script from "./raceManager.vue?vue&type=script&lang=js"
export * from "./raceManager.vue?vue&type=script&lang=js"

import "./raceManager.vue?vue&type=style&index=0&id=6b936f89&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b936f89"]])

export default __exports__